<div id="funds" class="order-container">
  <div class="row header">
    <div class="col-xs-12">
      <label class="title-name">Fondos</label>
      <div
        class="search-funds"
        (clickOutside)="closeWhenOutsideClick($event)"
        (attachOutsideOnClick)="(attachedClick)"
      >
        <div class="search">
          <input
            class="search"
            required
            [(ngModel)]="searchField"
            (focus)="setSearchResults(true)"
            (select)="setSearchResults(true)"
            [class.filled]="showResetButton === true"
            (keydown)="navDown($event)"
            (click)="$event.target.select()"
          />
          <label>Buscar fondo</label>
          <span *ngIf="selectedFund">{{
            selectedFund?.lastPrice
              | hbCustomFormat
                : (selectedFund?.lastPrice > 0 && selectedFund?.lastPrice < 1
                    ? '$0,0[.]00[0]'
                    : '$0,0[.]00')
          }}</span>
          <img
            class="reset-state"
            src="images/icons/atm-alert-icn-close.svg"
            (click)="setHardReset()"
            *ngIf="showResetButton"
          />
        </div>
        <ul class="result-list" *ngIf="showSearchResults">
          <ng-container
            *ngFor="
              let item of fondosList | searchfunds : 'issueID' : searchField
            "
          >
            <li
              *ngIf="item !== -1"
              tabindex="0"
              (keyup)="navDown($event)"
              class="option"
              (click)="setOrderType(item.issueID)"
              attr.data-issueid="{{ item.issueID }}"
            >
              <div class="item">
                {{ item.issueID }}
                <span>{{
                  item.lastPrice
                    | hbCustomFormat
                      : (item.lastPrice > 0 && item.lastPrice < 1
                          ? '$0,0[.]00[0]'
                          : '$0,0[.]00')
                }}</span>
              </div>
              <div class="fund">
                <div class="fund__name">
                  {{ item.issueName?.toLowerCase() }}
                </div>
                <div class="fund__type">
                  {{ FUNDS_TYPE[item.instrumentType] }}
                </div>
              </div>
            </li>
            <li class="option" *ngIf="item === -1">
              <div class="item">No se encontraron resultados</div>
            </li>
          </ng-container>
        </ul>
      </div>
    </div>
  </div>

  <div class="non-empty" [class.display-none]="emptyState === false">
    <div class="row puppet__position">
      <h6 class="position-title">Posición en portafolio</h6>
      <div class="col-xs-6">
        <div class="row">
          <div class="col-xs-5 padding-subcontent">
            <span class="label">Disp. p/vender</span>
          </div>
          <div class="col-xs-6 end-xs">
            <span class="label bold" *ngIf="!shouldDisplayIssueData">
              {{ missingInformationText }}
            </span>
            <span
              *ngIf="shouldDisplayIssueData"
              class="label bold"
              data-recording-sensitive
              >{{ position.shares | hbCustomFormat : '0,0' }}</span
            >
          </div>
        </div>
        <div class="row">
          <div class="col-xs-5">
            <span class="label">Plus/Minus</span>
          </div>
          <div class="col-xs-6 end-xs">
            <span class="label bold" *ngIf="!shouldDisplayIssueData">
              {{ missingInformationText }}
            </span>
            <span
              class="label bold"
              *ngIf="shouldDisplayIssueData"
              [class.neutro]="position.var === 0"
              [class.positive]="position.var > 0"
              [class.negative]="position.var < 0"
              data-recording-sensitive
            >
              {{
                position.plusMinus
                  | hbCustomFormat
                    : (position.plusMinus > 0 && position.plusMinus < 1
                        ? '$0,0[.]00[0]'
                        : '$0,0[.]00')
              }}
            </span>
          </div>
        </div>
      </div>
      <div class="col-xs-6">
        <div class="row end-xs">
          <div class="col-xs-5 start-xs padding-subcontent">
            <span class="label">Fecha de liq.</span>
          </div>
          <div class="col-xs-6 end-xs">
            <span *ngIf="!shouldDisplayIssueData" class="label bold">
              {{ missingInformationText }}
            </span>
            <span
              *ngIf="shouldDisplayIssueData"
              class="label bold"
              data-recording-sensitive
            >
              {{ position.liqDate }}
            </span>
          </div>
        </div>
        <div class="row end-xs">
          <div class="col-xs-5 start-xs">
            <span class="label">% Var. hist.</span>
          </div>
          <div class="col-xs-6 end-xs">
            <span class="label bold" *ngIf="!shouldDisplayIssueData">
              {{ missingInformationText }}
            </span>
            <span
              class="label bold"
              *ngIf="shouldDisplayIssueData"
              [class.neutro]="position.var === 0"
              [class.positive]="position.var > 0"
              [class.negative]="position.var < 0"
              data-recording-sensitive
              >{{ position.var | hbCustomFormat : '0[.]00%' }}</span
            >
          </div>
        </div>
      </div>
      <div class="link" *ngIf="this.selectedFund?.fundURL">
        <a
          href="{{ this.selectedFund.fundURL }}"
          target="_blank"
          rel="noopener noreferrer"
          >Ver detalle del fondo</a
        >
      </div>
    </div>

    <ng-container *ngIf="operationUnit === fundsOperationUnits.amount">
      <hb-input-money
        label="Monto aproximado"
        placeholder="$0.000"
        prefix="$"
        [(value)]="totalToSpend"
        (valueChange)="obtainTitlesEquivalent($event)"
        (focusout)="setTotal(totalToSpend)"
        [disabled]="!selectedFund || showOutOfService"
        [isError]="isInputInvalid"
      >
        <div *ngIf="userHasIssue" class="link link--button">
          <button
            type="button"
            (click)="sellEverything()"
            [disabled]="!selectedFund || showOutOfService || !userHasIssue"
          >
            Vender todo
          </button>
        </div>
      </hb-input-money>
    </ng-container>
    <ng-container *ngIf="operationUnit === fundsOperationUnits.titles">
      <hb-input-money
        label="Títulos"
        placeholder="0"
        [addSteppers]="true"
        [restrictToIntegers]="true"
        [value]="titles"
        (valueChange)="setTitles($event)"
        (focusout)="setTitles(titles)"
        [disabled]="!selectedFund || showOutOfService"
        [isError]="isInputInvalid"
      >
        <div *ngIf="userHasIssue" class="link link--button">
          <button
            type="button"
            (click)="sellEverything()"
            [disabled]="!selectedFund || showOutOfService"
          >
            Vender todo
          </button>
        </div>
      </hb-input-money>
    </ng-container>

    <div class="unit-switcher">
      <span>
        <ng-container *ngIf="operationUnit === fundsOperationUnits.amount">
          Títulos: <strong>{{ titles | hbCustomFormat : '0,0' }}</strong>
        </ng-container>

        <ng-container *ngIf="operationUnit === fundsOperationUnits.titles">
          Monto:
          <strong>{{ totalToSpend | hbCustomFormat : '$0,0.0000' }}</strong>
          <br />
          <span class="unit-switcher__legend"
            >Puede variar al completarse la orden</span
          >
        </ng-container>
      </span>

      <button
        (click)="switchOperationUnits()"
        class="right button button--transparent"
      >
        <img src="/images/icons/atm-icn-switch.svg" alt="Intercambiar" />
      </button>
    </div>

    <div
      class="funds-operation-notice information-card"
      *ngIf="!showOutOfService && !showMessageRI && selectedFund"
    >
      <div class="information-card__container">
        <div
          class="information-card__leading-icon information-card__leading-icon--info"
        ></div>
        <div class="information-card__information">
          <p>
            El monto de la compra o venta puede variar dependiendo del cambio en
            el precio del título al efectuar la operación
          </p>
        </div>
      </div>
    </div>

    <div
      class="funds-operation-notice information-card"
      *ngIf="showOutOfService || showMessageRI"
    >
      <div class="information-card__container">
        <div
          class="information-card__leading-icon information-card__leading-icon--info"
        ></div>
        <div class="information-card__information" *ngIf="!showMessageRI">
          <strong>La siguiente fecha de operación de este fondo es:</strong>
          <p *ngIf="!showBuyMessage && !showSellMessage">
            {{ operationDate }} de {{ openTradeTime }} a
            {{ closeTradeTime }} hrs.
          </p>
          <p *ngIf="showBuyMessage">
            Compra: {{ buyOperationDate }} de {{ openTradeTime }} a
            {{ closeTradeTime }} hrs.
          </p>
          <p *ngIf="showSellMessage">
            Venta: {{ sellOperationDate }} de {{ openTradeTime }} a
            {{ closeTradeTime }} hrs.
          </p>
        </div>
        <div class="information-card__information" *ngIf="showMessageRI">
          <p>
            Fuera de horario. Puedes procesar la solicitud desde el chat, con tu
            asesor o llamando a Relación con el Inversionista (CDMX 55 5480 6677
            / INT. 800 717 7480) antes de las
            {{ externalFundCloseOperationHour }} hrs.
          </p>
        </div>
      </div>
    </div>

    <div
      class="actions"
      *ngIf="canOperate && !isDiscretional && isGeolocationEnabled"
    >
      <button (click)="tryBuy()" class="btn-compra">
        <div class="button button--loading" *ngIf="isBuyButtonLoading">
          <div class="button__loader">
            <div class="dot"></div>
            <div class="dot"></div>
            <div class="dot"></div>
          </div>
        </div>
        {{ isBuyButtonLoading ? '' : 'Comprar' }}
      </button>
      <button (click)="trySell()" class="btn-venta">
        <div class="button button--loading" *ngIf="isSellButtonLoading">
          <div class="button__loader">
            <div class="dot"></div>
            <div class="dot"></div>
            <div class="dot"></div>
          </div>
        </div>
        {{ isSellButtonLoading ? '' : 'Vender' }}
      </button>
    </div>
  </div>

  <div class="modal" *ngIf="showConfirmation">
    <div class="mask" (click)="cancelConfirmation()"></div>
    <div class="container">
      <div class="row issue">
        <div class="issue-title">{{ selectedFund.issueID }}</div>
        <div class="issue-subtitle">
          {{ selectedFund.issueName?.toLowerCase() }}
        </div>
      </div>

      <div class="row">
        <div class="left">Monto</div>
        <div class="right" data-recording-sensitive>
          {{ titles * fundPrice | hbCustomFormat : '$0,0.0000' }}
        </div>
      </div>

      <div class="row">
        <div class="left">Títulos</div>
        <div class="right" data-recording-sensitive>
          {{ titles | hbCustomFormat : '0,0' }}
        </div>
      </div>

      <div class="row">
        <div class="left">Precio</div>
        <div class="right" data-recording-sensitive>
          {{ fundPrice | hbCustomFormat : '$0,0.0000' }}
        </div>
      </div>

      <div class="row help-message" *ngIf="showMessageMMA === true">
        <div class="left">
          <div class="info-icon icon-help-blue"></div>
        </div>
        <div class="right">
          Recuerda que el monto mínimo para operar el fondo
          {{ this.selectedFund.issueID }} es de $100,000.00MXN
        </div>
      </div>

      <div class="information-card">
        <div class="information-card__container">
          <div
            class="information-card__leading-icon information-card__leading-icon--info"
          ></div>
          <div class="information-card__information">
            <p *ngIf="order?.bitBuy">
              Verás lo títulos de la compra reflejados en tu portafolio el día
              <strong> {{ this.settlementBuyDate }}</strong>
            </p>
            <p *ngIf="!order?.bitBuy">
              Verás el monto de la venta reflejado en tu portafolio el día
              <strong> {{ this.settlementSellDate }}</strong>
            </p>
          </div>
        </div>
      </div>

      <div class="row actions">
        <button
          (click)="cancelConfirmation()"
          type="button"
          class="button button--small button--transparent"
          [class.button--disabled]="lockConfirmation"
        >
          Cancelar
        </button>
        <button
          *ngIf="!lockConfirmation"
          (click)="doMovement()"
          type="button"
          class="button__withdrawal button button--small button--dark"
        >
          {{ copyCallToAction }}
        </button>
        <button
          *ngIf="lockConfirmation"
          class="button button--small button--dark button--loading button--disabled"
          disabled
        >
          <div class="button__loader">
            <div class="dot"></div>
            <div class="dot"></div>
            <div class="dot"></div>
          </div>
        </button>
      </div>
    </div>
  </div>
</div>
